import { AccountApis } from "./accounts/accountSchemas";
import { InviteApis } from "./accounts/inviteSchemas";
import { AdminApis } from "./admin/adminSchema";
import { LocizeApis } from "./admin/locizeSchemas";
import { AuthApis } from "./auth/authSchemas";
import { AvatarApis } from "./avatars/avatarSchemas";
import { BybcatApis } from "./bybcat/bybcatSchemas";
import { ChallengeApis } from "./challenges/challengeSchemas";
import { GuideApis } from "./guides/guideSchema";
import { NoteApis } from "./notes/noteSchemas";
import { PlaylistApis } from "./playlists/playlistSchemas";
import { ProgressionApis } from "./progression/progressionSchemas";
import { ProjectApis } from "./projects/projectSchemas";
import { ReplayApis } from "./replays/replaySchemas";
import { ReportApis } from "./reports/reportsSchemas";
import { RewardApis } from "./rewards/rewardSchemas";
import { ScenarioApis } from "./scenarios/scenarioSchemas";
import { SecureApis } from "./secure/secureSchemas";
import { SessionApis } from "./sessions/sessionSchemas";
import { StatsApis } from "./stats/statsSchemas";
import { StreamingSkeletalApis } from "./streaming/skeletal/streamingSkeletalSchemas";
import { StripeApis } from "./stripe/stripeSchemas";
import { TagApis } from "./tags/tagSchemas";
import { TeamApis } from "./teams/teamSchemas";
import { TrackingApis } from "./tracking/trackingSchemas";
import { TrainingPlanApis } from "./training-plans/trainingPlanSchemas";
import { UserApis } from "./users/userSchemas";

export const Api = {
  ...NoteApis,
  ...TagApis,
  ...RewardApis,
  ...ChallengeApis,
  ...ScenarioApis,
  ...UserApis,
  ...StatsApis,
  ...SessionApis,
  ...SecureApis,
  ...AccountApis,
  ...AvatarApis,
  ...TeamApis,
  ...PlaylistApis,
  ...ProjectApis,
  ...ProgressionApis,
  ...GuideApis,
  ...AuthApis,
  ...AdminApis,
  ...BybcatApis,
  ...StripeApis,
  ...InviteApis,
  ...TrackingApis,
  ...ReportApis,
  ...ReplayApis,
  ...StreamingSkeletalApis,
  ...TrainingPlanApis,
  ...LocizeApis,
};
